import { OrderResponseDto } from '@planning/app/api'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import { MRT_TableInstance } from 'material-react-table'
import { action, makeObservable, observable } from 'mobx'

export class ReleaseDetailsViewStore {
  selectedOrder?: OrderResponseDto
  isAssignDialogOpen = false
  tableRef?: MRT_TableInstance<IOrderItem>

  constructor(public releaseId: number) {
    makeObservable(this, {
      releaseId: observable,
      selectedOrder: observable,
      isAssignDialogOpen: observable,
      tableRef: observable,

      setSelectedOrder: action,
      setIsAssignDialogOpen: action,
      setTableRef: action,
    })
  }

  setSelectedOrder = (order: OrderResponseDto) => {
    this.selectedOrder = order
  }

  setIsAssignDialogOpen = (isOpen: boolean) => {
    this.isAssignDialogOpen = isOpen
  }

  setTableRef = (tableRef: MRT_TableInstance<IOrderItem>) => {
    this.tableRef = tableRef
  }
}
